import { render, staticRenderFns } from "./wishassess.vue?vue&type=template&id=71831dc3&scoped=true&"
import script from "./wishassess.vue?vue&type=script&lang=js&"
export * from "./wishassess.vue?vue&type=script&lang=js&"
import style0 from "./wishassess.vue?vue&type=style&index=0&id=71831dc3&scoped=true&lang=less&"
import style1 from "./wishassess.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71831dc3",
  null
  
)

export default component.exports